var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bg valign-wrapper",attrs:{"id":"site-login"}},[(_vm.$store.getters.platform !== 'browser')?_c('div',{staticClass:"wrapper"},[_c('Login',{attrs:{"title":_vm.$t('SETTINGS.LOGIN')}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c53a2bd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/site/LoginTv.vue
// module id = null
// module chunks = 